import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import { formatDate } from 'utils/helpers'

type GetColumnsParams = {
  page: number
  onView: (id: string) => void
}

export const getColumns = ({ page, onView }: GetColumnsParams) =>
  [
    {
      headerName: '#',
      field: 'orderId',
      maxWidth: 80,
      valueFormatter: (params: ValueFormatterParams) => {
        return (params.node?.rowIndex as number) + 1 + page
      },
    },
    {
      headerName: 'Type',
      field: 'recordType',
      maxWidth: 110,
      cellRenderer: (params: ICellRendererParams) => {
        // Rows logged before RMA sync have no type and are all orders
        const isRma = params.value === 'RMA'
        return (
          <span
            className={`rounded-lg px-2 py-1 text-sm ${
              isRma
                ? 'bg-purple-100 text-purple-700'
                : 'bg-blue-100 text-blue-700'
            }`}
          >
            {isRma ? 'RMA' : 'Order'}
          </span>
        )
      },
    },
    {
      headerName: 'Order No',
      field: 'orderNo',
      minWidth: 150,
    },
    {
      headerName: 'RMA No',
      field: 'rmaNo',
      minWidth: 150,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Event Type',
      field: 'eventType',
      minWidth: 130,
      cellRenderer: (params: ICellRendererParams) => {
        const v: string = params.value
        if (!v) return <span>-</span>
        return (
          <span
            className={`rounded-lg px-2 py-1 text-sm ${
              v === 'CREATED'
                ? 'bg-blue-100 text-blue-700'
                : 'bg-gray-200 text-gray-600'
            }`}
          >
            {v === 'CREATED' ? 'Created' : 'Canceled'}
          </span>
        )
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      minWidth: 120,
      cellRenderer: (params: ICellRendererParams) => {
        const v: string = params.value
        if (!v) return <span>-</span>
        return (
          <span
            className={`rounded-lg px-2 py-1 text-sm ${
              v === 'SUCCESS'
                ? 'bg-green-400 text-black'
                : 'bg-red-500 text-white'
            }`}
          >
            {v === 'SUCCESS' ? 'Success' : 'Failed'}
          </span>
        )
      },
    },
    {
      headerName: 'Response Code',
      field: 'responseCode',
      maxWidth: 150,
      valueFormatter: (params: ValueFormatterParams) => params.value ?? '-',
    },
    {
      headerName: 'Error Message',
      field: 'errorMessage',
      minWidth: 200,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Synced At',
      field: 'syncedAt',
      minWidth: 180,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value ? formatDate(params.value, { includeTime: true }) : '-',
    },
    {
      headerName: 'Created At',
      field: 'createdAt',
      minWidth: 180,
      valueFormatter: (params: ValueFormatterParams) =>
        formatDate(params.value, { includeTime: true }),
    },
    {
      headerName: 'Actions',
      field: '_id',
      maxWidth: 100,
      sortable: false,
      cellRenderer: (params: ICellRendererParams) => (
        <button
          type="button"
          className="text-sm font-semibold text-sidebar-primary hover:underline"
          onClick={() => onView(params.value)}
        >
          View
        </button>
      ),
    },
  ] as ColDef[]
